import { findIndex } from "lodash";
//import sendxAPI from '../../../xAPI'

const templateState = {
  id: -1,
  type: null,
  held: false,
  inScene: true
};

export function StopperReducer(
  state = { stoppers: [] },
  action
) {
  let currentStopper;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
    return state;
  }

  if (
    action.type !== "CREATE_STOPPER" &&
    !action.type.includes("@redux")
  ) {
    if (action.payload.hasOwnProperty("id")) {
      if (
        state.protocolSection.scene.apparatus.hasOwnProperty("stoppers")
      ) {
        currentStopper =
          state.protocolSection.scene.apparatus.stoppers[
            findIndex(state.protocolSection.scene.apparatus.stoppers, {
              id: action.payload.id,
            })
          ];
      }
    }
  }

  switch (action.type) {
    case "CREATE_STOPPER":
      //Create new obj from template state
      let newObj = { ...templateState, ...action.payload.props };

      if (protocolSection.scene.apparatus.hasOwnProperty("stoppers")) {
        protocolSection.scene.apparatus.stoppers = [
          ...protocolSection.scene.apparatus.stoppers,
          newObj,
        ];
      } else {
        protocolSection.scene.apparatus.stoppers = [newObj];
      }

      return {
        ...state,
        ...{
          protocolSection: protocolSection,
        },
      };
    case "SET_STOPPER_HELD":
      currentStopper.held = action.payload.held;
      protocolSection.scene.apparatus.stoppers[findIndex(state.protocolSection.scene.apparatus.stoppers, { id: action.payload.id })] = currentStopper;
      return { ...state, ...{ protocolSection: protocolSection } };
      
    case "SET_STOPPERS_IN_SCENE":
    //Payload = {inScene}
    currentStopper.inScene = action.payload.inScene;
    protocolSection.scene.apparatus.stoppers[findIndex(state.protocolSection.scene.apparatus.stoppers, { id: action.payload.id })] = currentStopper;
    return { ...state, ...{ protocolSection: protocolSection } };
      
    case "UNDO":
      //Payload = {lastState}

      if (action.payload.lastState !== null && protocolSection.scene.apparatus.hasOwnProperty('stoppers')) {
        protocolSection.scene.apparatus.stoppers =
          action.payload.lastState.scene.apparatus.stoppers;

        return {
          ...state,
          ...{
            protocolSection: protocolSection,
          },
        };
      } else {
        return state;
      }

    default:
      return state;
  }
}
